import { render, staticRenderFns } from "./NavigationItems.vue?vue&type=template&id=c03328ba"
import script from "./NavigationItems.vue?vue&type=script&lang=js"
export * from "./NavigationItems.vue?vue&type=script&lang=js"
import style0 from "./NavigationItems.vue?vue&type=style&index=0&id=c03328ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports